import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";

/* eslint-disable @typescript-eslint/no-shadow, @typescript-eslint/ban-types */
import * as definitions from '../../definitions/analytics';
import { createAction } from '../../interfaces';
import analyticsService from '../../services/analytics';
import { getErrorMessageFromErrorResponse, handleErrorResponse } from '../../utils/error';
export var analyticsActionCreators = {
  getEventStatsRequest: function getEventStatsRequest(serviceId) {
    return createAction(definitions.GET_EMAIL_SIGNUPS_REQUEST, serviceId);
  },
  getEventStatsSuccess: function getEventStatsSuccess(payload) {
    return createAction(definitions.GET_EMAIL_SIGNUPS_SUCCESS, payload);
  },
  getEventStatsFail: function getEventStatsFail(error) {
    return createAction(definitions.GET_EMAIL_SIGNUPS_FAIL, error);
  },
  getResourcesRequest: function getResourcesRequest(payload) {
    return createAction(definitions.GET_RESOURCES_REQUEST, payload);
  },
  getResourcesSuccess: function getResourcesSuccess(payload) {
    return createAction(definitions.GET_RESOURCES_SUCCESS, payload);
  },
  getResourcesFail: function getResourcesFail(error) {
    return createAction(definitions.GET_RESOURCES_FAIL, error);
  },
  getMetricsRequest: function getMetricsRequest() {
    return createAction(definitions.GET_METRICS_REQUEST);
  },
  getMetricsSuccess: function getMetricsSuccess(payload) {
    return createAction(definitions.GET_METRICS_SUCCESS, payload);
  },
  getMetricsFail: function getMetricsFail(error) {
    return createAction(definitions.GET_METRICS_FAIL, error);
  },
  getTopicsRequest: function getTopicsRequest() {
    return createAction(definitions.GET_TOPICS_REQUEST);
  },
  getTopicsSuccess: function getTopicsSuccess(payload) {
    return createAction(definitions.GET_TOPICS_SUCCESS, payload);
  },
  getTopicsFail: function getTopicsFail(error) {
    return createAction(definitions.GET_TOPICS_FAIL, error);
  },
  clearAnalyticsErrors: function clearAnalyticsErrors() {
    return createAction(definitions.CLEAR_ANALYTICS_ERRORS);
  },
  setAnalyticsInfo: function setAnalyticsInfo(info) {
    return createAction(definitions.SET_ANALYTICS_INFO, info);
  },
  clearAnalyticsInfo: function clearAnalyticsInfo() {
    return createAction(definitions.CLEAR_ANALYTICS_INFO);
  },
  clearAnalyticsData: function clearAnalyticsData() {
    return createAction(definitions.CLEAR_ANALYTICS_DATA);
  },
  getEventsRequest: function getEventsRequest(serviceId) {
    return createAction(definitions.GET_EVENTS_REQUEST, serviceId);
  },
  getEventsSuccess: function getEventsSuccess(payload) {
    return createAction(definitions.GET_EVENTS_SUCCESS, payload);
  },
  getEventsFail: function getEventsFail(error) {
    return createAction(definitions.GET_EVENTS_FAIL, error);
  }
};
export var clearAnalyticsErrors = function clearAnalyticsErrors() {
  return function (dispatch) {
    var clearAnalyticsErrors = analyticsActionCreators.clearAnalyticsErrors;
    dispatch(clearAnalyticsErrors());
  };
};
export var setAnalyticsInfo = function setAnalyticsInfo(info) {
  return function (dispatch) {
    var setAnalyticsInfo = analyticsActionCreators.setAnalyticsInfo;
    dispatch(setAnalyticsInfo(info));
  };
};
export var clearAnalyticsData = function clearAnalyticsData() {
  return function (dispatch) {
    var clearAnalyticsData = analyticsActionCreators.clearAnalyticsData;
    dispatch(clearAnalyticsData());
  };
};
export var clearAnalyticsInfo = function clearAnalyticsInfo() {
  return function (dispatch) {
    var clearAnalyticsInfo = analyticsActionCreators.clearAnalyticsInfo;
    dispatch(clearAnalyticsInfo());
  };
};
export var getEventStats = function getEventStats(serviceId, payload) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var getEventStatsRequest, getEventStatsSuccess, getEventStatsFail;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getEventStatsRequest = analyticsActionCreators.getEventStatsRequest, getEventStatsSuccess = analyticsActionCreators.getEventStatsSuccess, getEventStatsFail = analyticsActionCreators.getEventStatsFail;
              dispatch(getEventStatsRequest(serviceId));
              return _context.abrupt("return", analyticsService.getEventStats(serviceId, payload).then(function (payload) {
                dispatch(getEventStatsSuccess(payload));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getEventStatsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getEvents = function getEvents(serviceId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var getEventsRequest, getEventsSuccess, getEventsFail;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              getEventsRequest = analyticsActionCreators.getEventsRequest, getEventsSuccess = analyticsActionCreators.getEventsSuccess, getEventsFail = analyticsActionCreators.getEventsFail;
              dispatch(getEventsRequest(serviceId));
              return _context2.abrupt("return", analyticsService.getServiceEvents(serviceId).then(function (payload) {
                dispatch(getEventsSuccess(payload));
              }, function (error) {
                dispatch(getEventsFail(error));
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getResources = function getResources(payload) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var getResourcesRequest, getResourcesSuccess, getResourcesFail;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              getResourcesRequest = analyticsActionCreators.getResourcesRequest, getResourcesSuccess = analyticsActionCreators.getResourcesSuccess, getResourcesFail = analyticsActionCreators.getResourcesFail;
              dispatch(getResourcesRequest(payload));
              return _context3.abrupt("return", analyticsService.getResources(payload).then(function (resources) {
                dispatch(getResourcesSuccess(resources));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getResourcesFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var getTopic = function getTopic(payload) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var getTopicsRequest, getTopicsSuccess, getTopicsFail;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              getTopicsRequest = analyticsActionCreators.getTopicsRequest, getTopicsSuccess = analyticsActionCreators.getTopicsSuccess, getTopicsFail = analyticsActionCreators.getTopicsFail;
              dispatch(getTopicsRequest());
              return _context4.abrupt("return", analyticsService.getTopic(payload).then(function (topic) {
                dispatch(getTopicsSuccess(topic));
                return topic;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getTopicsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var getMetrics = function getMetrics() {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var getMetricsRequest, getMetricsSuccess, getMetricsFail;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              getMetricsRequest = analyticsActionCreators.getMetricsRequest, getMetricsSuccess = analyticsActionCreators.getMetricsSuccess, getMetricsFail = analyticsActionCreators.getMetricsFail;
              dispatch(getMetricsRequest());
              return _context5.abrupt("return", analyticsService.getMetrics().then(function (metrics) {
                dispatch(getMetricsSuccess(metrics));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getMetricsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};